import {Grid} from "@mui/material";
import moment from "moment";
import {useContext} from "react";
import {ClientInfoContext, PDFProjectContext} from "../../../pages/project/shopdrawing/openings/OpeningsPDF";
import {api} from "../../../api/API";
import {Project} from "../../../api/Projects";
import {RedactedContext} from "../RedactedContext";
import {Page} from "./Page";
import {fixPdfPath} from "./FullSizeImage";

export const pdfInfo = {
    logo: fixPdfPath("/images/pdf-logo.png"),
    handleLogo: fixPdfPath("/images/handle-2.png"),
    companyName: "Tykel Commercial Door Supply Inc",
    address1: "138 Sugar Maple Rd",
    address2: "St. George, ON",
    postal: "N0E 1N0",
    hstNumber: "71341 7319 RT0001"
}

export const tykelWarehouseLocation = {
    street: "138 Sugar Maple Rd",
    city: "St. George",
    postal: "N0E 1N0"
}

export function CoverPage(props: {
    title: string;
    lastSubmittal: string|null;
    portrait?: boolean;
}) {
    const project = useContext(PDFProjectContext);
    const redacted = useContext(RedactedContext);
    const {client, clientContact} = useContext(ClientInfoContext);

    return (
        <Page orientation={props.portrait ? "portrait" : undefined}>
            <div style={{
                flex: 1,
                display: "flex",
                alignItems: "center",
                flexDirection: "column",
                position: "relative",
                fontSize: "1rem",
                height: "100%",
            }}>
                <div style={{height: props.portrait ? 150 : 40}} />
                <div style={{fontWeight: "bold", textAlign: "center", fontSize: "2rem"}}>
                    {props.title}
                </div>

                <div style={{flex: props.portrait ? undefined : 1, height: props.portrait ? 100 : undefined}} />

                <div style={{
                    fontWeight: "bold",
                    display: "flex",
                    flexDirection: "column",
                    alignItems: "center",
                }}>
                    <div style={{fontSize: "1.6rem"}}>
                        {redacted ? (project.nameAlias || project.name) : project.name}
                    </div>
                    {!redacted && <>
                        <div>{project.addressStreet}</div>
                        <div>{project.addressCity}, {project.addressProvince}</div>
                        <div>{project.addressPostal}</div>
                    </>}
                    <div>
                        Version: {project.versionCode}
                    </div>
                </div>
                <div style={{flex: props.portrait ? undefined : 1, height: props.portrait ? 100 : undefined}} />

                <Grid container>
                    {!redacted && client && <>
                        <Grid item xs={6}>
                            <div style={{display: "flex", flexDirection: "column", alignItems: "center"}}>
                                <div style={{fontWeight: "bold"}}>
                                    {client.name}
                                </div>
                                <div>{client.addressStreet}</div>
                                <div>{client.addressCity}, {client.addressProvince}</div>
                                <div>{client.addressPostal}</div>
                                {clientContact && <div>{clientContact.name} {clientContact.phone}</div>}
                            </div>
                        </Grid>
                    </>}
                    <Grid item xs={6}>
                        <div style={{display: "flex", flexDirection: "column", alignItems: "center"}}>
                            <div style={{fontWeight: "bold"}}>{pdfInfo.companyName}</div>
                            <div>{pdfInfo.address1}</div>
                            <div>{pdfInfo.address2}</div>
                            <div>{pdfInfo.postal}</div>
                            {project.projectManager ?
                                <><div>{combineStrs(project.pmName, decorate(project.pmTitle, "(", ")"), decorate(project.pmPhone, "- "))}</div></> :
                                <>{
                                    (project.estimators || []).map(v =>
                                        <div>{combineStrs(v.name, decorate(v.title, "(", ")"), decorate(v.phone, "- "))}</div>
                                    )
                                }</>}
                        </div>
                    </Grid>
                </Grid>

                <div style={{flex: props.portrait ? undefined : 1, height: props.portrait ? 50 : undefined}} />

                <div style={{display: "flex", flexDirection: "column", alignItems: "center"}}>
                    <div>Previous Submission: {props.lastSubmittal ? moment.utc(props.lastSubmittal).format("MMM D, YYYY") : "(none)"}</div>
                    <div style={{fontWeight: "bold"}}>Submittal Date: {moment().format("MMM D, YYYY")}</div>
                </div>

                <div style={{height: props.portrait ? 100 : 10}} />

                <div style={{
                    width: "100%",
                    display: "flex", justifyContent: "flex-end", paddingRight: 40
                }}>
                    <img alt="Tykel Logo" src={pdfInfo.logo} style={{width: props.portrait ? 250 : 300}} />
                </div>
            </div>
        </Page>
    )
}

export function decorate(value: string|undefined|null, before: string, after: string = "") {
    if(!value) return undefined;
    return before + value + after;
}

export function combineStrs(...input: (string|undefined)[]) {
    return input.filter(v => !!v).join(" ")
}

export async function getPDFClient(project: Project) {
    if(project.contractor) {
        return api.companies.get({id: project.contractor})
    }

    if(project.client) {
        return api.companies.get({id: project.client})
    }

    return undefined;
}
